import { render, staticRenderFns } from "./EditOrganizationForm.vue?vue&type=template&id=28e4e4cf&scoped=true"
import script from "./EditOrganizationForm.vue?vue&type=script&lang=js"
export * from "./EditOrganizationForm.vue?vue&type=script&lang=js"
import style0 from "./EditOrganizationForm.vue?vue&type=style&index=0&id=28e4e4cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e4e4cf",
  null
  
)

export default component.exports